import { render, staticRenderFns } from "./NotificationItemCard.vue?vue&type=template&id=dbe91096&scoped=true&"
import script from "./NotificationItemCard.vue?vue&type=script&lang=js&"
export * from "./NotificationItemCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemCard.vue?vue&type=style&index=0&id=dbe91096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe91096",
  null
  
)

export default component.exports